<template>
  <section>
    <h4 class="form-card-header">{{ __('001_common.user.parent') }}</h4>
    <div ref="generalInfoForm" class="form-card-form">
      <div>
        <label for="p_lastname">{{ $t('registration.lastname') }}:<span class="text-danger">*</span></label>
        <input
          id="p_lastname"
          name="parent_lastname"
          size="sm"
          type="text"
          class="pi-input"
          :placeholder="$t('registration.lastname')"
          v-model="v$.form.lastname.$model"
          @blur="v$.form.lastname.$touch()"
        />
        <div class="error-message" v-show="v$.form.lastname.$errors.length">
          <div v-show="!v$.form.lastname.$errors.required">{{ $t('helper.name-regex') }}</div>
          <div v-show="!v$.form.lastname.$errors.max">{{ $t('helper.text-count', { slot: '45' }) }}</div>
        </div>
      </div>

      <div>
        <label for="p_firstname">{{ $t('registration.firstname') }}:<span class="text-danger">*</span></label>
        <input
          id="p_firstname"
          name="parent_firstname"
          size="sm"
          type="text"
          class="pi-input"
          :placeholder="$t('registration.firstname')"
          v-model="v$.form.firstname.$model"
          @blur="v$.form.firstname.$touch()"
        />
        <div class="error-message" v-show="v$.form.firstname.$errors.length">
          <div v-show="!v$.form.firstname.$errors.required">{{ $t('helper.name-regex') }}</div>
          <div v-show="!v$.form.firstname.$errors.max">{{ $t('helper.text-count', { slot: '45' }) }}</div>
        </div>
      </div>

      <div>
        <label for="p_register_number">{{ $t('registration.register-number') }} / {{ $t('registration.passport-number') }}:<span class="text-danger">*</span></label>
        <div class="d-flex">
          <input type="text"
                 name="parent_register_number"
                 size="sm"
                 class="pi-input"
                 id="p_register_number"
                 v-model="v$.form.number.$model"
                 @blur="v$.form.number.$touch()"
                 :class="v$.form.number.$errors.length ? 'border-red-400 focus:border-red-500 focus:ring-offset-red-500' : ''"
                 placeholder="********"/>
        </div>
        <div v-show="v$.form.number.$errors.length">
          <div class="error-message">{{ $t('helper.please-enter-proper-number') }}</div>
        </div>
      </div>

      <div>
        <label for="p_phone_number">{{ $t('registration.phone-number') }}:<span class="text-danger">*</span></label>
        <input
          id="p_phone_number"
          name="parent_phone_number"
          size="sm"
          type="number"
          class="pi-input"
          placeholder="********"
          v-model="v$.form.phoneNumber.$model"
          @blur="v$.form.phoneNumber.$touch()"
        />
        <div class="error-message" v-show="v$.form.phoneNumber.$errors.length">
          <div v-show="!v$.form.phoneNumber.$errors.required">{{ $t('helper.please-fill') }}</div>
          <div v-show="!v$.form.phoneNumber.$errors.min">{{ $t('helper.min-text-count', { slot: '8' }) }}</div>
        </div>
      </div>

      <section class="sub-step-buttons-container">
        <ic-button size="tn" type="button" color="grey" @click="previous()" class="d-flex align-items-center mr-3"><i class="sr sr-chevron-left"></i>{{ $t('button.previous') }}</ic-button>
        <ic-button size="tn" type="button" variant="success"  @click="next()" class="d-flex align-items-center ml-3">{{ $t('button.next') }} <i class="sr sr-chevron-right"></i></ic-button>
      </section>
    </div>
  </section>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, numeric, minLength, maxLength } from '@vuelidate/validators'
import { nameRegexValidator } from '../../mixins/regex'
import api from '../../api/createUser'
import {CompanyInfo} from "../../utils/constants";

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      form: {
        number: null,
        lastname: null,
        firstname: null,
        phoneNumber: null,
        CompanyInfo
      },
    }
  },
  validations() {
    return {
      form: {
        number: { required, min: minLength(8) },
        lastname: { required, max: maxLength(45), nameRegexValidator },
        firstname: { required, max: maxLength(45), nameRegexValidator },
        phoneNumber: { required, min: minLength(8), numeric },
      }
    }
  },
  mounted() {
    this.fillOldData()
  },
  methods: {
    previous() {
      this.$emit('previous')
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async next() {
      await this.v$.$validate()
      if (!this.v$.$error) {
        try {
          const {data} = await api.checkParent(this.form.number)
          if(data.status !== 200)
            this.$bvToast.toast(
                `Эхлээд асран хамгаалагчийн мэдээллийг ${CompanyInfo.name} -д бүртгүүлнэ үү!`,
                {title: 'Асран хамгаалагч бүртгэлгүй байна', variant: 'warning'},
            )
          else this.$emit('next', this.form)
        } catch (e) {
          this.$bvToast.toast(
              'Асран хамгаалагчийн мэдээлэл шалгахад алдаа гарлаа',
              {title: 'Алдаа', variant: 'danger'},
          )
        }
      } else {
        console.log(this.v$.$error)
        alert(`${ this.$('helper.please-fill-required-fields') }`)
      }
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    fillOldData() {
      if (!window.oldInputs) return;
      if (window.oldInputs['parent_firstname']) {
        this.$set(this.form, 'parent_firstname', window.oldInputs['parent_firstname']);
      }
      if (window.oldInputs['parent_lastname']) {
        this.$set(this.form, 'parent_lastname', window.oldInputs['parent_lastname']);
      }
      if (window.oldInputs['parent_register_number']) {
        this.$set(this.form, 'parent_register_number', window.oldInputs['parent_register_number']);
      }
      if (window.oldInputs['parent_phone_number']) {
        this.$set(this.form, 'parent_phone_number', window.oldInputs['parent_phone_number']);
      }
    }
  },
}
</script>